import React, { useState } from "react";
import Header from "components/Header/Header";
import PaymentHeader from "components/PaymentHeader/PaymentHeader";
import PaymentMethods, {PaymentMethod} from "components/PaymentMethods/PaymentMethods";
import PaymentInstructions from "components/PaymentInstructions/PaymentInstructions";
import ContactUsSection from "components/ContactUsSection/ContactUsSection";
import Footer from "components/Footer/Footer";

const PaymentPage = () => {
    const [method, setMethod] = useState<PaymentMethod>('card')

    return (
        <div className='overlay'>
            <Header />
            <PaymentHeader />
            <PaymentMethods value={method} onChange={setMethod}/>
            <PaymentInstructions method={method}/>
            <ContactUsSection />
            <Footer />
        </div>
    );
};

export default PaymentPage;